<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" v-for="stats in statsCards">
        <stats-card :type="stats.type"
                    :icon="stats.icon"
                    :small-title="stats.title"
                    :title="stats.value">
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i>
            {{stats.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    
    <div style="width:100%;">
  		  <!-- start open tasks -->
    	<div class="card" style="margin-bottom:100px;margin-top:80px;">
          <div class="card-header">
              <h5 class="title">Open Adhoc Tasks</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="incomplete_adhoc_tasks" @row-click="editTask" style="cursor:pointer" >
            <el-table-column label="Created" property="created_at_str"  width="150"></el-table-column>
            	<el-table-column label="Entity" property="entity_name"  width="300"></el-table-column>
                <el-table-column label="Task" property="task_name" ></el-table-column>
                <el-table-column label="Deadline" property="deadline_date_str" width="150"></el-table-column>
                <el-table-column label="Task Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.task_status===1">Pending</span>
           				 <span v-if="scope.row.task_status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.task_status===3">Signed</span>
           				 <span v-if="scope.row.task_status===4">Completed</span>
           				 <span v-if="scope.row.task_status===5">Cancaelled</span>
          			</template>
                </el-table-column>
                
                <el-table-column label="Payment Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.payment_status===1">Paid</span>
           				 <span v-if="scope.row.payment_status===2">Not Paid</span>
           				 <span v-if="scope.row.payment_status===3">Not Applicable</span>
           				 <span v-if="scope.row.payment_status===4">Refunded</span>
          			</template>
                </el-table-column>

            </el-table>

          </div>
        </div>
        <!-- end open tasks -->
    
    
    
    
    </div>
    
    <div class="row">
	<div class="col-md-6">
		 <!-- start scheduled tasks: next 30 days -->
	    <div class="card" style="margin-bottom:100px">
          <div class="card-header">
              <h5 class="title">Tasks: Deadline In Next 30 Days</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="deadline_tasks_30d" @row-click="editTask" style="cursor:pointer" >
            	<el-table-column label="Entity" property="entity_name"></el-table-column>
                <el-table-column label="Task" property="task_name" ></el-table-column>
                <el-table-column label="Task Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.task_status===1">Pending</span>
           				 <span v-if="scope.row.task_status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.task_status===3">Signed</span>
           				 <span v-if="scope.row.task_status===4">Completed</span>
           				 <span v-if="scope.row.task_status===5">Cancaelled</span>
          			</template>
                </el-table-column>
				<el-table-column label="Deadline" property="deadline_date_str" ></el-table-column>
            </el-table>

          </div>
        </div>  
         <!-- end scheduled tasks: next 30 days -->
		 
	</div>
	
	
	
	<div class="col-md-6">
	  <!-- start scheduled tasks: next 30 days -->
	    <div class="card" style="margin-bottom:100px">
          <div class="card-header">
              <h5 class="title">Tasks: Scheduled In Next 30 Days</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="scheduled_reg_tasks_30d" @row-click="editTask" style="cursor:pointer" >
            	<el-table-column label="Entity" property="entity_name"></el-table-column>
                <el-table-column label="Task" property="task_name" ></el-table-column>
                <el-table-column label="Task Status" >
                
                	<template slot-scope="scope">
           				 <span v-if="scope.row.task_status===1">Pending</span>
           				 <span v-if="scope.row.task_status===2">Waiting For Signature</span>
           				 <span v-if="scope.row.task_status===3">Signed</span>
           				 <span v-if="scope.row.task_status===4">Completed</span>
           				 <span v-if="scope.row.task_status===5">Cancaelled</span>
          			</template>
                </el-table-column>
				<el-table-column label="Scheduled" property="schedule_date_str" ></el-table-column>
            </el-table>

          </div>
        </div>  
         <!-- end scheduled tasks: next 30 days -->
         
         
	</div>
	</div> <!-- end row -->
	
	
	
    <div class="row">
	<div class="col-md-6">
		 <!-- start unpaid invoices: next 60 days -->
       <div class="card" style="margin-bottom:100px">
          <div class="card-header">
              <h5 class="title">Billing: Due Next 60 Days</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="invoices_60d" @row-click="goToEntity" style="cursor:pointer" 
            		>
            	<el-table-column label="Entity" property="entity.entity_name"></el-table-column>	
            	<el-table-column label="title" property="title"></el-table-column>
                <el-table-column label="Amount" >
                
                	<template slot-scope="scope">
           				{{scope.row.amount_str}} {{scope.row.currency}}
          			</template>
                </el-table-column>
				<el-table-column label="Due Date" property="deadline_str"></el-table-column>	
            </el-table>

          </div>
        </div>  
        <!-- end unpaid invoices: next 60 days -->
        
    
    
    </div>
    <div class="col-md-6">
    	<!-- start overdue invoices -->
		 <div class="card" style="margin-bottom:100px">
			  <div class="card-header">
				  <h5 class="title">Billing: Past Due</h5>
			  </div>
			  <div class="card-body table-responsive table-full-width">
				<el-table :data="invoices_overdue" @row-click="goToEntity" style="cursor:pointer"  
				row-class-name="table-danger"
						>
					<el-table-column label="Entity" property="entity.entity_name"></el-table-column>	
					<el-table-column label="title" property="title"></el-table-column>
					<el-table-column label="Amount" >
				
						<template slot-scope="scope">
							{{scope.row.amount_str}} {{scope.row.currency}}
						</template>
					</el-table-column>
					<el-table-column label="Due Date" property="deadline_str"></el-table-column>	
				</el-table>

			  </div>
			</div>  
		 <!-- end overdue invoices -->
    
    
    </div>
    </div><!-- end row -->
        
     
        
    <div class="row">
	<div class="col-md-6">
          <!-- start agm deadlines: next 21 days --> 
    	 <div class="card" style="margin-bottom:100px">
          <div class="card-header">
              <h5 class="title">Next 21 Days: AGM Deadlines</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="agm_tasks_xd_arr" @row-click="goToEntity" style="cursor:pointer"  
            		:row-class-name="agmRowClassName">
            	<el-table-column label="Entity" property="entity_name"></el-table-column>
                <el-table-column label="UEN" property="uen" ></el-table-column>
                 <el-table-column label="Type" property="type" ></el-table-column>
                 <el-table-column label="Deadline" property="deadline" ></el-table-column>
                 <el-table-column label="Status" property="rt_status" ></el-table-column>
            </el-table>

          </div>
        </div>  
		<!-- end agm deadlines: next 21 days --> 
        
        
    </div>
    <div class="col-md-6">
    	 <!-- start AR deadlines: next 21 days --> 
		<div class="card" style="margin-bottom:100px">
          <div class="card-header">
              <h5 class="title">Next 21 Days: Annual Return Deadlines</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="ar_tasks_xd_arr" @row-click="goToEntity" style="cursor:pointer"  
           	 :row-class-name="arRowClassName"
            	>
            	<el-table-column label="Entity" property="entity_name"></el-table-column>
                <el-table-column label="UEN" property="uen" ></el-table-column>
                 <el-table-column label="Type" property="type" ></el-table-column>
                 <el-table-column label="Deadline" property="deadline" ></el-table-column>
                 <el-table-column label="AR Status" property="rt_status" ></el-table-column>
                  <el-table-column label="AGM Status" property="agm_status" ></el-table-column>
            </el-table>

          </div>
        </div>  
		 <!-- end AR deadlines: next 21 days --> 
    
    
    
    </div>
    </div><!-- end row -->

    
        


    
  <div style="text-align:center;font-size:12px;">Version {{app_version}}</div>
  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import {Badge} from 'src/components/UIComponents'
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue';
  import {CommonService} from 'src/services/common.service'
  import swal from 'sweetalert2'
	
 import ApiService from 'src/services/api.service';

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      Badge,

    },
    methods:{
    	agmRowClassName({ row }){
    		if(row.rt_status =="Not Scheduled" || row.rt_status =="Task Not Created"){
    			return "table-danger";
    		}
    	
    	},
    	arRowClassName({ row }){
    		if(row.rt_status != "Filed With ACRA"){
    			return "table-danger";
    		}
    	
    	},
    	goToEntity (row){
    		this.$router.push( '/view-entity/'+row.eid)
    	},
    	editTask (row) {
		
			this.$router.push( '/edit-task/'+row.id+"/entity/"+row.entity_id)
      	},
    
    },
    mounted() {
      let uri = this.$base_url+'/api/v1/entities/dashboard';
      ApiService.post(uri).then(response => {
      	if(response.data.app_version && this.app_version !=response.data.app_version){
      		 const vm = this;
      		 swal({
				  title: 'Refreshing System ...',
				  text: 'The version you are using is currently outdated.',
				  type: 'warning',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm.$router.go()
				
				})  	
      	}
      
      
      
      	let companies = response.data.entities;
      	this.num_live_entities = response.data.num_live_entities.toString();
      	this.num_incomplete_adhoc_tasks = response.data.num_incomplete_adhoc_tasks.toString();
      	this.num_scheduled_reg_tasks_30d = response.data.num_scheduled_reg_tasks_30d.toString();
      	this.num_deadline_reg_tasks_xd = response.data.num_deadline_reg_tasks_xd.toString();
      	
      	this.incomplete_adhoc_tasks = response.data.incomplete_adhoc_tasks;
      	this.scheduled_reg_tasks_30d = response.data.scheduled_reg_tasks_30d;
      	this.deadline_tasks_30d = response.data.deadline_tasks_30d;
      	//this.deadline_reg_tasks_xd = response.data.deadline_reg_tasks_xd;
      	
      	this.agm_tasks_xd_arr = response.data.agm_tasks_xd_arr;
      	this.ar_tasks_xd_arr = response.data.ar_tasks_xd_arr;
      	this.overdue_agm_arr = response.data.overdue_agm_arr;
      	this.overdue_ar_arr = response.data.overdue_ar_arr;
      	this.invoices_60d = response.data.invoices_60d
      	this.invoices_overdue = response.data.invoices_overdue
      	//alert("hit:"+this.num_live_entities);
         //this.tableData = companies;
         
         this.statsCards = [
          {
            type: 'warning',
            icon: 'nc-icon nc-shop',
            title: 'Entities',
            value: this.num_live_entities,
            footerText: 'Live entities under management',
            footerIcon: 'nc-icon nc-refresh-69'
          },
          {
            type: 'success',
            icon: 'nc-icon nc-paper',
            title: 'Open Adhoc Tasks',
            value: this.num_incomplete_adhoc_tasks,
            footerText: 'Adhoc tasks to complete',
            footerIcon: 'nc-icon nc-bell-55'
          },
          {
            type: 'danger',
            icon: 'nc-icon nc-briefcase-24',
            title: 'Scheduled Tasks',
            value: this.num_scheduled_reg_tasks_30d,
            footerText: 'In the next 30 days',
            footerIcon: 'nc-icon nc-calendar-60'
          },
          {
            type: 'info',
            icon: 'nc-icon nc-bell-55',
            title: 'Approaching Deadline',
            value: this.num_deadline_reg_tasks_xd,
            footerText: 'Filing deadlines In The Next 21 Days',
            footerIcon: 'nc-icon nc-bell-55'
          }
        ];
        
      })
    },
    data () {
      return {
      	num_live_entities:'',
      	num_incomplete_adhoc_tasks:'',
      	num_scheduled_reg_tasks_30d: '',
      	num_deadline_reg_tasks_xd:'',
      	invoices_60d:[],
      	invoices_overdue:[],
        statsCards: [],
        incomplete_adhoc_tasks:[],
        scheduled_reg_tasks_30d:[],
        deadline_tasks_30d:[],
        //deadline_reg_tasks_xd:[],
        agm_tasks_xd_arr:[],
        ar_tasks_xd_arr:[],
        app_version:CommonService.getAppVersion(),
        
      }
    }
  }

</script>
<style>

</style>
